import {CatalogReferenceFragment} from '../../../../gql/graphql';
import {CatalogReferenceModel} from './CatalogReference.model';
import {ItemSource} from '@wix/auto_sdk_ecom_cart-v-2';

export class SourceModel {
  public catalogReference?: CatalogReferenceModel;

  constructor(params: SourceModel) {
    this.catalogReference = params.catalogReference;
  }

  public static fromCheckoutV1(catalogReference?: CatalogReferenceFragment | null) {
    return new SourceModel({
      catalogReference: CatalogReferenceModel.fromCheckoutV1(catalogReference),
    });
  }

  public static fromCartV2(source: ItemSource): SourceModel {
    return new SourceModel({
      catalogReference: CatalogReferenceModel.fromCartV2(source.catalogReference!),
    });
  }
}
